import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { translations } from "@utils/translations";
import { setFilter } from "../store/actions";

export default function ResetButton({ resetHandler, className }) {
  const dispatch = useDispatch();
  const appSettings = useSelector(({ rootReducer }) => rootReducer.baseSettings);
  const lang = appSettings.searchLanguage ? appSettings.searchLanguage : "en";

  // eslint-disable-next-line no-unused-vars
  const translate = (s) => translations[lang][s] || s;

  const resetAll = () => {
    resetHandler();
    dispatch(setFilter(`#page=1&orderby=${appSettings.searchOrderby}&order=${appSettings.searchOrder}&value=${appSettings.searchValue}`, true));
  };

  return (
        // eslint-disable-next-line max-len
        <button type="submit" data-testid={"resetButton"} className={className} onClick={resetAll}>
            {translate("reset")}
        </button>
  );
}
